import React from 'react';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { ModalTemplate } from './ModalTemplate';
import { useTrial } from '../useTrial';
import useTrackTrialEvent from '../useTrackTrialEvent';
import { useSuggestedPlan, useTrackBillingEvent } from '~features/billing';
import { useLazyGetUsageOverviewQuery } from '~features/dashboard-v3/DashboardV3API';

function MidTrialModal() {
  const { isHalfwayThroughTrial, freeTrialState, updateFreeTrialState } = useTrial();
  const trackEvent = useTrackTrialEvent();
  const trackBillingEvent = useTrackBillingEvent();
  const suggestedPlan = useSuggestedPlan();
  const navigate = useNavigate();
  const [getUsageOverview, usageOverviewResult] = useLazyGetUsageOverviewQuery();

  const data = usageOverviewResult.data?.data;
  const { originalDeliveryTime, averageDeliveryTime } = data ?? {
    originalDeliveryTime: 0,
    averageDeliveryTime: 0,
  };
  const deliveryTimeImprovement =
    originalDeliveryTime && averageDeliveryTime
      ? Math.round(((originalDeliveryTime - averageDeliveryTime) / originalDeliveryTime) * 100)
      : 0;

  const shouldFetchData = isHalfwayThroughTrial && !freeTrialState.user.midTrialModalClosed;
  const open = shouldFetchData && deliveryTimeImprovement > 0;

  const onClose = () => {
    trackEvent('BannerClosed', { banner_name: 'MidTrial' });
    updateFreeTrialState({ state: { midTrialModalClosed: true }, scope: 'user' });
  };

  const handleUpgradeClick = () => {
    trackBillingEvent('UpgradeClicked', { cta_location: 'Mid Trial Modal', cta_name: 'Upgrade my plan' });
    updateFreeTrialState({ state: { midTrialModalClosed: true }, scope: 'user' });

    if (suggestedPlan) navigate(`/billing/plans?selectedPlan=${suggestedPlan.id}`);
    else navigate(`/billing/plans`);
  };

  React.useEffect(() => {
    if (shouldFetchData) getUsageOverview({ days: 14 });
  }, [shouldFetchData]);

  React.useEffect(() => {
    if (open) {
      trackEvent('BannerShown', { banner_name: 'MidTrial' });
    }
  }, [open]);

  return (
    <ModalTemplate
      title={`Congrats! Your delivery time improved by ${deliveryTimeImprovement}%`}
      open={open}
      cancelText="Close"
      cancelButtonProps={{ type: 'text' }}
      okText="Upgrade my plan"
      okButtonProps={{ variant: 'outlined', color: 'primary' }}
      onCancel={onClose}
      onOk={handleUpgradeClick}
      loading={usageOverviewResult.isLoading}
    >
      <Typography.Text>
        Your customers are seeing your pages quicker in search results. Upgrade your plan to keep the momentum going.
      </Typography.Text>
    </ModalTemplate>
  );
}

export default MidTrialModal;
